var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 20 Copy"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 14,
    cy: 14,
    r: 13.5,
    fill: "#23A24D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 0.75C10.3348 0.75 7.00888 2.2037 4.54999 4.56699V13.1382L13.9768 25.0465C13.9863 25.0542 14 25.0475 14 25.0356C14 25.0475 14.0137 25.0546 14.0231 25.0465L23.45 13.1382V4.56699C20.9911 2.2037 17.6652 0.75 14 0.75Z",
    fill: "#EBD6BD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 16.95C12.3668 16.95 10.9091 17.8207 9.95001 19.1835L13.9787 25.0463C13.9874 25.0544 14 25.0473 14 25.0346C14 25.0473 14.0126 25.0549 14.0214 25.0463L18.05 19.1835C17.0909 17.8207 15.6333 16.95 14 16.95Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.675 0.75C13.0137 0.75 11.4228 1.04617 9.95001 1.58285V9.17203L14.6519 12.8969C14.6613 12.9044 14.675 12.8974 14.675 12.8857C14.675 12.8974 14.6887 12.9044 14.6982 12.8969L19.4 9.17203V1.58285C17.9272 1.04617 16.3363 0.75 14.675 0.75Z",
    fill: "#EBBA16"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.72495 12.8735L8.59999 9.41954V2.09998C7.07759 2.72453 5.70221 3.68844 4.54999 4.91183V12.7797C4.54999 12.8803 4.65448 12.9363 4.72495 12.8735Z",
    fill: "#ED8A19"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4 9.41954L23.2751 12.8735C23.3455 12.9363 23.45 12.8803 23.45 12.7797V4.91183C22.2978 3.68844 20.9224 2.72453 19.4 2.09998V9.41954Z",
    fill: "#ED8A19"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScore);
export default __webpack_public_path__ + "static/media/score.65c35d6e9a569557a96f3c69908667b7.svg";
export { ForwardRef as ReactComponent };